module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_omiya-cb851e7897d1a481db878256410006b2.jpg";